<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel">
			<el-form-item label="门锁别名"><br>
				<el-input v-model="inputmodel['lockAlias']" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="房源编号" prop="room_num"><br>
				<el-select style="width: 100%;" v-model="inputmodel.room_num" placeholder="请选择房间"
					v-el-select-loadmore="loadmore" @change="changeselect">
					<el-option v-for=" item in options" :key="item.id" :label="item.flat+`—`+item.room_num"
						:value="item.room_num">
					</el-option>
				</el-select>
			</el-form-item>


		</el-form>

		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>
<script>
	import {
		lock_bind_room,
		get_house,
		contract_edit,
		house_list
	} from "@/api/api.js"
	import {
		BASEURL
	} from "@/Utils/request.js";

	export default {
		directives: {
			'el-select-loadmore': {
				bind(el, binding) {
					const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
					SELECTWRAP_DOM.addEventListener('scroll', function() {
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				}
			}
		},
		props: [
			"item"
		],
		data() {
			return {
				name: '',
				inputmodel: {
					lockid: '',
					rid: ''
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 0,
					rent_status: 0
				},

				fwq: [], // 用于存储服务器返回的图片URL
				// 富文本编辑器配置

			}
		},
		methods: {
			qx(i) {
				console.log(this.inputmodel);

				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							this.inputmodel.lockid = this.item.lockId
							lock_bind_room(this.inputmodel).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				// this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				get_house(formData).then(res => {
					const _res = res.data
					this.options = [...this.options, ..._res];
				})

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
			formatAmount(field) {
				if (this.inputmodel[field] !== undefined && typeof this.inputmodel[field] === 'number') {
					this.inputmodel[field] = parseFloat(this.inputmodel[field].toFixed(2));
				}
			},
			// 多选框
			changeselect(value) {
				// value 是被选中的房间号
				const fieldsToUpdate = ['rent', 'deposit', 'property_fee'];

				// 查找对应的 item
				const selectedItem = this.options.find(item => item.room_num === value);
				if (selectedItem) {
					console.log('Selected item:', selectedItem);
					this.inputmodel.rid = selectedItem.id;

					house_list({
						room_num: value
					}).then(res => {
						// 检查并更新 inputmodel 中的字段
						fieldsToUpdate.forEach(field => {
							const fieldValue = res.data.list[0][field];
							if (typeof fieldValue === 'number') {
								this.inputmodel[field] = parseFloat(fieldValue.toFixed(2));
							} else {
								this.inputmodel[field] = fieldValue; // 如果不是数字类型，则直接赋值
							}
						});
					});
				}
			},





		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			house_list({
				limit: 999999999,
				page: 1
			}).then(res => {
				const _res = res.data.list
				this.options = _res;
			})
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);
				this.inputmodel = JSON.parse(JSON.stringify(this.item));


			}
		},



	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>